import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, delay, map, Observable, of, switchMap } from 'rxjs';

import { RoutingPaths } from '@features/enrollment/enums';
import { ReconciliateResponse } from '@features/global/interfaces';
import { ReconciliateIkpiService } from '@features/global/services/reconciliate-ikpi.service';
import { globalActions } from '@features/global/store/actions';
import { ReconciliateTop } from '@features/reconciliation/enums/reconciliate-top.enum';

@Injectable()
export class GlobalEffects {
  private readonly actions$: Actions = inject(Actions);

  private readonly globalService: ReconciliateIkpiService = inject(ReconciliateIkpiService);

  private readonly router: Router = inject(Router);

  private readonly translate: TranslateService = inject(TranslateService);

  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  public Reconciliate$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(globalActions.reconciliateAdd),
      switchMap(({ urlParams }) =>
        this.globalService.reconciliate(urlParams).pipe(
          delay(2000),
          map((reconciliateResponse: ReconciliateResponse) => {
            if (reconciliateResponse?.reconciliateTop === ReconciliateTop.EXIST) {
              window.location.replace(this.translate.instant(`urls.external.home`));
            } else if (reconciliateResponse?.reconciliateTop === ReconciliateTop.IDENTITY) {
              this.router.navigate([RoutingPaths.PERSONAL_INFORMATION], {
                queryParams: this.activatedRoute.snapshot.queryParams,
              });
            }
            return globalActions.reconciliateCompleted({
              reconciliateResponse,
            });
          }),
          catchError((error) => {
            return of(globalActions.reconciliateError({ error }));
          }),
        ),
      ),
    );
  });
}
